"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var react_ga_1 = __importDefault(require("react-ga"));
function useGA() {
    var location = (0, react_router_dom_1.useLocation)();
    var _a = (0, react_1.useState)(false), initializedGA = _a[0], setInitializedGA = _a[1];
    (0, react_1.useEffect)(function () {
        if (process.env.MIX_ANALYTICS_GOOGLE_ANALYTICS &&
            process.env.MIX_ANALYTICS_GOOGLE_ANALYTICS !== 'UA-XXXXX-X' &&
            process.env.NODE_ENV === 'production') {
            react_ga_1.default.initialize(process.env.MIX_ANALYTICS_GOOGLE_ANALYTICS);
            setInitializedGA(true);
        }
    }, []);
    (0, react_1.useEffect)(function () {
        if (initializedGA) {
            react_ga_1.default.pageview(location.pathname + location.search);
        }
    }, [location, initializedGA]);
}
exports.default = useGA;
